import * as React from 'react'
import {FC, memo} from 'react'
import Form from 'antd/lib/form'
import 'antd/lib/form/style'
import Row from 'antd/lib/row'
import 'antd/lib/row/style'
import Col from 'antd/lib/col'
import 'antd/lib/col/style'
import CalcCard from '../../../../common/components/calc-card'
import IDS from '../../constants/ids'
import {ProgramInfo} from '../../types/models/program-info'
import Select from 'antd/lib/select'
import 'antd/lib/select/style'
import {COMPONENT_SIZE} from '../../constants'
import {STANDARD_ITEM_RULES_SELECT} from '../../../../common/constants'
import LABELS from '../../constants/labels'

interface HandlingInfoPropsInterface {
    onValueChange: (fieldName: string | string[]) => void
    programInfo: ProgramInfo
}

const {Item} = Form,
    {Option} = Select

const HandlingInfo: FC<HandlingInfoPropsInterface> = memo(({onValueChange, programInfo}) => {
    return (
        <CalcCard>
            <h2>Хранение и погрузо-разгрузочные работы</h2>
            <Row gutter={{xs: 24, sm: 24, md: 24, xl: 24}}>
                <Col xs={24} sm={12} md={12} lg={12}>
                    <Item
                        name={IDS.TRANSPORT_STORAGE}
                        label={LABELS.TRANSPORT_STORAGE}
                        rules={STANDARD_ITEM_RULES_SELECT}
                        required
                    >
                        <Select
                            className='e-full-wide'
                            placeholder='Укажите кол-во дней хранения'
                            size={COMPONENT_SIZE}
                            onChange={() => {
                                onValueChange(IDS.TRANSPORT_GUARD)
                            }}
                        >
                            {programInfo.storage.map((storageType, index) => (
                                <Option
                                    value={storageType.count}
                                    key={`transport-storage-${storageType.count}`}
                                >
                                    {storageType.count === 0
                                        ? 'Нет'
                                        : 'До ' + storageType.count + ' дней'}
                                </Option>
                            ))}
                        </Select>
                    </Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                    <Item
                        name={IDS.TRANSPORT_LOADING_COUNT}
                        label={LABELS.TRANSPORT_LOADING_COUNT}
                        rules={STANDARD_ITEM_RULES_SELECT}
                        required
                    >
                        <Select
                            className='e-full-wide'
                            placeholder='Укажите кол-во погрузок/разгрузок'
                            size={COMPONENT_SIZE}
                            onChange={() => {
                                onValueChange(IDS.TRANSPORT_SHIPPING)
                            }}
                        >
                            <Option value='0' key='transport-reloads-0'>
                                НЕТ погрузо-разгрузочных работ
                            </Option>
                            {programInfo.loading.dimension.map((reloadsCounter, index) => (
                                <Option
                                    value={reloadsCounter.count}
                                    key={`transport-reloads-${reloadsCounter.count}`}
                                >
                                    {reloadsCounter.count === 1
                                        ? '1 погрузка или 1 разгрузка (всего 1)'
                                        : reloadsCounter.count === 2
                                        ? '1 погрузка и 1 разгрузка (всего 2)'
                                        : reloadsCounter.count === 4
                                        ? '2 погрузки/разгрузки (всего 4)'
                                        : reloadsCounter.count === 6
                                        ? '3 погрузки/разгрузки (всего 6)'
                                        : reloadsCounter.count === 8
                                        ? '4 погрузки/разгрузки (всего 8)'
                                        : reloadsCounter.count === 10
                                        ? '5 погрузок/разгрузок (всего 10)'
                                        : 'Неизвестно'}
                                </Option>
                            ))}
                        </Select>
                    </Item>
                </Col>
            </Row>
        </CalcCard>
    )
})

export default HandlingInfo
